import React, { Fragment, useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, Col, Form, FormGroup, Input, Label, Media, Modal, ModalBody, ModalFooter, ModalHeader, Row, Table } from 'reactstrap';
import { Breadcrumbs, H5, ToolTip } from '../../AbstractElements';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Edit, Filter, PlusCircle, X } from 'react-feather';
import { FormLabel } from 'react-bootstrap';
import MyPagination from '../pagination';
import axiosInstance from '../../interceptor/intercetptor-inctence';
import Loader from "../../Layout/Loader";
import { useLoader } from '../../_helper/LoaderContext';
import { secureApiRequest } from '../../Services/secureApiRequest';
import { decryptResponseData } from '../../Services/decryptApiResponse';

const ChangePassword = () => {
    const { setLoading } = useLoader();
    const { t } = useTranslation();
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [errors, setErrors] = useState({});
    const [toggleOldPassword, setToggleOldPassword] = useState(false);
    const [toggleNewPassword, setToggleNewPassword] = useState(false);
    const [toggleConfirmPassword, setToggleConfirmPassword] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = {};

        // Validation for old password
        if (!oldPassword.trim()) {
            errors.oldPassword = t("Old password is required");
        }

        // Validation for new password
        if (!newPassword.trim()) {
            errors.newPassword = t("New password is required");
        } else if (newPassword.length < 8) {
            errors.newPassword = t("New password must be at least 8 characters long");
        }

        // Validation for confirm password
        if (!confirmPassword.trim()) {
            errors.confirmPassword = t("Confirm password is required");
        } else if (confirmPassword !== newPassword) {
            errors.confirmPassword = t("Passwords do not match");
        }

        // Set errors
        setErrors(errors);

        // If there are errors, prevent form submission
        if (Object.keys(errors).length > 0) {
            return;
        }

        try {
            const body = {
                old_password: oldPassword,
                new_password: newPassword,
                confirm_password: confirmPassword
            }
            setLoading(true);
            // const response = await axiosInstance.patch(`/clinic_admin/profile/change/password`, body);
            const response = await secureApiRequest("patch", `/clinic_admin/profile/change/password`, body);
            const dec_data = decryptResponseData(response);
            // const dec_data = response.data;
            if (dec_data.status === 'success') {
                toast.success(dec_data.message);
                setOldPassword("");
                setNewPassword("");
                setConfirmPassword("");
                toDashboard();
                setLoading(false);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
        finally {
            // End loading
            setLoading(false);
        }
        // If no errors, proceed with form submission logic
        console.log("Form submitted:", { oldPassword, newPassword });
    };

    const history = useNavigate();

    const toDashboard = () => {
        history(`${process.env.PUBLIC_URL}/dashboard`);
    };

    return (
        <Fragment>
            <Breadcrumbs mainTitle={t("Change Password")} parent={t("Dashboard")} title={t("Change Password")} />

            <Col sm="12">
                <Card>
                    {/* <CardHeader className="d-flex justify-content-between align-items-center">
                        <H5>{t("Change Password")}</H5>
                    </CardHeader> */}
                    <CardBody>

                        <Col lg="12">
                            <Form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className='col-md-4'>
                                        <div className="mb-3">
                                            <FormLabel className="form-label">{t("Old password")} <span className="text-danger">*</span></FormLabel>
                                            <div className="position-relative">
                                                <Input
                                                    type={toggleOldPassword ? "text" : "password"}
                                                    className="form-control"
                                                    placeholder={t("Old password")}
                                                    value={oldPassword}
                                                    onChange={(e) => setOldPassword(e.target.value)}
                                                    required=""
                                                />
                                                <div className="show-hide" onClick={() => setToggleOldPassword(!toggleOldPassword)}>
                                                    {toggleOldPassword ? (
                                                        <i className="fa fa-eye"></i>
                                                    ) : (
                                                        <i className="fa fa-eye-slash"></i>
                                                    )}
                                                </div>
                                            </div>
                                            {errors.oldPassword && <div className="text-danger">{errors.oldPassword}</div>}
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className="mb-3">
                                            <FormLabel className="form-label">{t("New password")} <span className="text-danger">*</span></FormLabel>
                                            <div className="position-relative">
                                                <Input
                                                    type={toggleNewPassword ? "text" : "password"}
                                                    className="form-control"
                                                    placeholder={t("New password")}
                                                    value={newPassword}
                                                    onChange={(e) => setNewPassword(e.target.value)}
                                                    required=""
                                                />
                                                <div className="show-hide" onClick={() => setToggleNewPassword(!toggleNewPassword)}>
                                                    {toggleNewPassword ? (
                                                        <i className="fa fa-eye"></i>
                                                    ) : (
                                                        <i className="fa fa-eye-slash"></i>
                                                    )}
                                                </div>
                                            </div>
                                            {errors.newPassword && <div className="text-danger">{errors.newPassword}</div>}
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className="mb-3">
                                            <FormLabel className="form-label">{t("Re-type New password")} <span className="text-danger">*</span></FormLabel>
                                            <div className="position-relative">
                                                <Input
                                                    type={toggleConfirmPassword ? "text" : "password"}
                                                    className="form-control"
                                                    placeholder={t("Re-type New password")}
                                                    value={confirmPassword}
                                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                                    required=""
                                                />
                                                <div className="show-hide" onClick={() => setToggleConfirmPassword(!toggleConfirmPassword)}>
                                                    {toggleConfirmPassword ? (
                                                        <i className="fa fa-eye"></i>
                                                    ) : (
                                                        <i className="fa fa-eye-slash"></i>
                                                    )}
                                                </div>
                                            </div>
                                            {errors.confirmPassword && <div className="text-danger">{errors.confirmPassword}</div>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-6"></div>
                                    <div className="col-3">
                                        <button type="submit" className="btn btn-primary w-100">{t("Change Password")}</button>
                                    </div>
                                    <div className="col-3">
                                        <button type="button" className="btn btn-danger w-100" onClick={toDashboard}>{t("Cancel")}</button>
                                    </div>
                                </div>
                            </Form>
                        </Col>
                    </CardBody>
                </Card>
            </Col>
        </Fragment>
    );
};

export default ChangePassword;
